import { Button, Divider, List, Space, Tag } from "antd";
import React, { useEffect, useState } from "react"
import { CalendarOutlined, PhoneTwoTone, HourglassOutlined, LeftOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../model/rootReducer";
import { getCallEventsAction } from "../../../../business/actions/analyticsActions";
import { Timeline } from 'antd';
import "moment/locale/fr";
import moment from "moment";
import { Item, ReturnButton, StyledTag } from "./Styled";

type AnalyticsDrawerProps = {
    data?: any;
    visible: boolean;
}

const AnalyticsDetails: React.FunctionComponent<AnalyticsDrawerProps> = ({
    data,
    visible
}) => {
    const eventColor = "blue"
    const targetedEventColor = "green"
    const dateFormat = "DD/MM/YYYY - HH:mm:ss"
    const events = useSelector(
        (state: RootState) => state.analytics.events
    )
    const [timelineView, setTimelineView] = useState("")
    const [timelineItem, setTimelineItem] = useState<any>([])

    useEffect(() => {
        if (!visible) setTimelineView("")
        else {
            setTimelineItem([])
        }
    }, [visible])

    useEffect(() => {
        if (events && timelineView) {
            events.forEach((value, index) => {
                var color: string
                if (value.type == data.group) color = targetedEventColor
                else color = eventColor
                setTimelineItem((old: any) => [...old, <Timeline.Item color={color} key={index}>{value.type} - {value.totalMilliseconds} ms</Timeline.Item>])
            });
        }
    }, [events])

    const dispatch = useDispatch()
    return (<>
        {!timelineView && <>
            <Tag color="blue">{data.eventCounter} événements</Tag>
            <Tag color="green"> {data.callIds.length} appels</Tag>
            <Divider />
            <List
                dataSource={data.callIds}
                renderItem={(callId: any) => (
                    <Item onClick={() => { dispatch(getCallEventsAction.request(callId)); setTimelineView(callId) }}>
                        {callId}
                    </Item>
                )}
            />
        </>}
        {timelineView && <>
            {events.length > 0 && <>
                <ReturnButton type="text" shape="circle" icon={<LeftOutlined />} onClick={() => setTimelineView("")} />
                <br />
                <StyledTag color="blue" icon={<PhoneTwoTone />}>{timelineView}</StyledTag>
                <Space>
                    <StyledTag color="green" icon={<CalendarOutlined />}>{moment(events[0].start).utc().format(dateFormat)}</StyledTag>
                    <StyledTag icon={<HourglassOutlined />}>
                        {
                            moment.duration(moment(events[events.length - 1].end).utc().diff(events[0].start)).humanize()
                        }</StyledTag>
                </Space>
            </>}
            <Divider />
            <Timeline mode="alternate">
                {timelineItem}
            </Timeline>
        </>
        }
    </>
    )
}

export default AnalyticsDetails